export default __webpack_public_path__ + "static/media/1565.630b024a.png";